"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chZones = void 0;
var chZones = exports.chZones = [{
  id: 'BERNE',
  name: 'Berne',
  country: 'CH',
  cornerNW: {
    latitude: 46.9851,
    longitude: 7.3590
  },
  cornerSE: {
    latitude: 46.9127,
    longitude: 7.4876
  },
  subZones: [{
    name: 'Bern Innenstadt',
    zipcodes: {
      3000: {
        label: '3000'
      }
    }
  }, {
    name: 'Bern Westquartiere',
    zipcodes: {
      3006: {
        label: '3006'
      }
    }
  }, {
    name: 'Bern Nordquartiere',
    zipcodes: {
      3011: {
        label: '3011'
      }
    }
  }, {
    name: 'Bern Länggasse',
    zipcodes: {
      3012: {
        label: '3012'
      }
    }
  }, {
    name: 'Bern Bethlehem',
    zipcodes: {
      3018: {
        label: '3018'
      }
    }
  }]
}];